import * as gfunctions from '../../../js/generalFunctions';

CCL.multipleSailing = {
  autoload: [
    ['dropdownClick', $('.userSelect-item').length > 0],
    ['modalEvents', $('#multipleSailingModal').length > 0]
  ],
  dropdownClick() {
    $('.userSelect-item').click((e) => {
      $('#sailingDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },

  modalEvents() {
    const modalEl = $('#multipleSailingModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-multiple-sailing-modal/multiple-sailing-modal.js